import src from "IMAGE";
export default { src, width: 133, height: 200, blurWidth: 5, blurHeight: 8, blurDataURL: "data:image/webp;base64,UklGRmQAAABXRUJQVlA4TFgAAAAvBMABAM1VICICHgiADQIAAICLgz8dhlyAcIAwAQBwAANwAAAAAAAAAAAAAAAAAAgAhwOi0C8wThYAACAiclym8g2eUDuQn3F9RMWwUbIG5r31O1c+j+sF"};
